import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { Check, Gauge } from "lucide-react";
import closeModal from "../../assets/images/closeModal.svg";
import "../DesignationLevel/DynamicModal.css";
import TextField from "../designSystem/TextField";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import fuelService from "../../services/fuel.service";
import { t } from "../../locales/translate";

const EditVehicleAverageModal = ({ onClose, editData, onSave }) => {
  const [average, setAverage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData?.average != null) {
      setAverage(String(editData.average));
    }
  }, [editData]);

  const handleSave = async (e) => {
    e.preventDefault();
    const parsed = parseFloat(average);
    if (!average || Number.isNaN(parsed) || parsed <= 0) {
      setError(t("invalidVehicleAverage"));
      return;
    }
    setError("");
    setLoading(true);
    try {
      const response = await fuelService.saveVehicleAverage({
        id: editData?.id ?? 0,
        average: parsed,
      });
      if (response.data?.status) {
        onSave(response.data.result?.[0] ?? { id: editData?.id, average: parsed });
      }
    } catch (err) {
      console.error("Error saving vehicle average:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container overlay-wrapper">
        <LoadingOverlay isVisible={loading} />
        <div className={loading ? "blur" : ""}>
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <Gauge color="white" size={24} />
              </div>
              <div className="text">
                <h2 className="modalheading">{t("editVehicleAverage")}</h2>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>

          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">
              <TextField
                name="average"
                label={`${t("averageKmPerLiter")} *`}
                type="number"
                value={average}
                onChange={(e) => setAverage(e.target.value)}
                placeholder={t("input")}
                error={error}
              />
            </div>
            <div className="dynamicmodal-footer">
              <CancelButton onClick={onClose} text={t("cancel")} />
              <PrimaryButton text={t("save")} icon={Check} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditVehicleAverageModal;
